// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8777) return "8777." + __webpack_require__.h() + ".css";
	// return url for filenames based on template
	return "" + "index" + "." + __webpack_require__.h() + ".css";
};